import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api from "../lib/api";

export const Footer = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success(t("footer.nlOk"));
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="border-t border-primary/10 mt-24 relative z-10" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 pt-12 pb-4" data-testid="newsletter-block">
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-7 flex flex-col md:flex-row md:items-center gap-6">
          <div className="flex-1">
            <p className="font-serif-display text-xl">{t("footer.nlTitle")}</p>
            <p className="text-sm text-muted-foreground mt-1">{t("footer.nlText")}</p>
          </div>
          <form onSubmit={subscribe} className="flex w-full md:w-auto gap-3">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder={t("footer.nlPlaceholder")}
              className="flex-1 md:w-72 px-4 py-2.5 rounded-full border border-primary/30 bg-background text-sm focus:outline-none focus:border-primary"
              data-testid="newsletter-email-input" />
            <button type="submit" disabled={busy}
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary text-primary-foreground text-sm font-medium hover:bg-[#16528A] transition-colors duration-200 disabled:opacity-50"
              data-testid="newsletter-submit-btn">
              <Send size={14} /> {t("footer.nlBtn")}
            </button>
          </form>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
        <div className="flex items-start gap-4">
          <img src="/logo-fondation.jpg" alt="Fondation Sèlide Kouzen-Kouzin" className="w-14 h-14 rounded-full border border-primary/25 object-cover" />
          <div>
            <p className="font-serif-display text-xl text-primary">Chimen Nanm</p>
            <p className="text-sm text-muted-foreground mt-1">{t("footer.tagline")}</p>
          </div>
        </div>
        <div className="text-sm text-foreground/70 space-y-1.5">
          <p className="font-medium text-foreground">Fondation Sèlide Kouzen-Kouzin du Canada</p>
          <p>OBNL — Enregistrement fédéral 1250962-8 · Business # 798508347RC0001 · Montréal, Québec</p>
          <p><a href="mailto:fondationselide@gmail.com" className="hover:text-primary">fondationselide@gmail.com</a> · +1 438-923-5961</p>
          <p><a href="https://www.fondationselide.org" target="_blank" rel="noopener noreferrer" className="hover:text-primary underline underline-offset-4">www.fondationselide.org</a></p>
        </div>
        <div className="md:text-right">
          <Link to="/fondation" className="text-sm text-primary hover:underline underline-offset-4" data-testid="footer-foundation-link">{t("nav.foundation")}</Link>
          <p className="text-xs text-muted-foreground mt-3">© 2026 {t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
};
